import Vue from "vue";
import Vuex from "vuex";
import router from "../../routes";
import ApiService from "../../services/api.services";
import { TokenService } from "../../services/auth/storage.services.js";
import {
  AuthenticationError,
  UserService
} from "../../services/users/user.services";

Vue.use(Vuex);

const state = {
  companyId: "",
  prefixRoute: "",
  authenticating: false,
  accessToken: TokenService.getToken(),
  loggedIn: TokenService.getToken() ? true : false,
  authenticationErrorCode: 0,
  authenticationError: ""
};

const getters = {
  getCompanyId: state => {
    return state.companyId || localStorage.getItem("companyId");
  },

  getPrefixRoute: state => {
    return state.prefixRoute || localStorage.getItem("prefixRoute");
  },

  loggedIn: state => {
    return state.accessToken ? true : false;
  },

  authenticationErrorCode: state => {
    return state.authenticationErrorCode;
  },

  authenticationError: state => {
    return state.authenticationError;
  },

  authenticating: state => {
    return state.authenticating;
  }
};

const actions = {
  async login({ commit }, { email, password }) {
    commit("loginRequest");

    try {
      const token = await UserService.login(email, password);
      commit("loginSuccess", token);
      state.accessToken = token;
      TokenService.saveToken(token);
      ApiService.setHeader(token);
      const me = await UserService.me();
      const prefix = me.user.companies[0].prefix;
      commit("changePrefixRoute", prefix);
      return true;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit("loginError", {
          errorCode: e.errorCode,
          errorMessage: e.message
        });
      }
      throw e;
    }
  },

  logout({ commit }) {
    const prefixBeforeLogout = localStorage.getItem("prefixRoute");
    UserService.logout();
    commit("logoutSuccess");
    router.push({
      name: "login-prefix",
      params: { prefix: prefixBeforeLogout }
    });
  },

  actionCompanyId({ commit }, id) {
    commit("changeCompanyId", id);
  },

  actionPrefixRoute({ commit }, prefix) {
    commit("changePrefixRoute", prefix);
  }
};

const mutations = {
  changeCompanyId(state, newCompanyId) {
    localStorage.setItem("companyId", newCompanyId);
    state.companyId = newCompanyId;
  },

  changePrefixRoute(state, newPrefixRoute) {
    localStorage.setItem("prefixRoute", newPrefixRoute);
    state.prefixRoute = newPrefixRoute;
  },

  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = "";
    state.authenticationErrorCode = 0;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  loginError(state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.accessToken = null;
    state.companyId = null;
    state.prefixRoute = null;
    localStorage.clear();
  }
};

const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default auth;

export { auth };
